import ComponentConfig from './component-config';

export default class BaseComponent {
    constructor(element, { props, id }) {
        this.id = id;

        this._isDestroyed = false;
        this.element = element;
        this.props = props || {};
        this.options = {};
        this.refs = {};

        this.checkRequiredProps(this.props);

        if (this.id) {
            this.initOptions();
            this.initRefs();
        }

        this.checkRequiredRefs(this.refs);
    }

    static getRequiredProps() {
        return [];
    }

    static getRequiredRefs() {
        return [];
    }

    initOptions() {
        let options = {};
        let datasetOptionsProperty = ComponentConfig.getDatasetOptionsProperty(this.id);
        if (this.element.dataset && (datasetOptionsProperty in this.element.dataset)) {
            try {
                options = JSON.parse(this.element.dataset[datasetOptionsProperty]);
            } catch (error) {
                console.error(`Unable to parse options from ${datasetOptionsProperty} on element:`, this.element);
                return;
            }
        }
        this.options = options;
    }

    initRefs() {
        let refs = {};
        let refElements = [...this.element.querySelectorAll(`[${ComponentConfig.getRefProperty(this.id)}]`)];
        if (refElements.length) {
            refElements.forEach((element) => {
                let datasetRefProperty = ComponentConfig.getDatasetRefProperty(this.id);
                if (element.dataset && (datasetRefProperty in element.dataset)) {
                    ComponentConfig.insertToCollection(refs, element.dataset[datasetRefProperty], element);
                }
            });
        }
        this.refs = refs;
    }

    checkRequiredProps(props) {
        this.constructor.getRequiredProps().forEach(name => {
            if (!props[name]) {
                throw new Error(`the value of required prop ${name} is ${props[name]}`);
            }
        })
    }

    checkRequiredRefs(refs) {
        this.constructor.getRequiredRefs().forEach(name => {
            if (!refs[name]) {
                throw new Error(`the value of required ref ${name} is ${refs[name]}`);
            }
        })
    }

    destroy() {
        this._isDestroyed = true;
        this.onDestroy();
    }

    isDestroyed() {
        return this._isDestroyed;
    }

    onDestroy() {
        // hook for children
    }
}



// WEBPACK FOOTER //
// ./app/general/js/base-component.js